import React from 'react';

import {
  currencyRangeColumn,
  simpleColumn,
  withoutSum,
} from '../utils/column-helpers';
import {
  created,
  createdBy,
  modified,
  modifiedBy,
  name,
} from '../utils/columns';
import DuplicateButton from './DuplicateButton';
import MarkPrimaryButton from './MarkPrimaryButton';
import QuoteLink from './QuoteLink';

export const primary = {
  Header: '#1',
  accessor: 'id',
  width: 32,
  filterable: false,
  Cell: row => {
    const { isDisabled, onUpdatePrimaryQuote, primaryQuoteId } =
      row.tdProps.rest;
    return (
      <MarkPrimaryButton
        id={row.value}
        opportunityId={row.original.opportunityId}
        currentPrimary={primaryQuoteId}
        onSuccess={onUpdatePrimaryQuote}
        disabled={isDisabled}
      />
    );
  },
};

export const duplicate = {
  Header: '',
  accessor: 'id',
  filterable: false,
  sortable: false,
  className: 'text-right',
  Cell: row => {
    const { reloadData, isDisabled } = row.tdProps.rest;
    return (
      <DuplicateButton
        id={row.value}
        onSuccess={reloadData}
        disabled={isDisabled}
      />
    );
  },
};

export const nameLink = {
  Header: 'Name',
  accessor: 'name',
  Cell: row => <QuoteLink model={row.original} />,
};

export const objective = simpleColumn('Objective', 'campaignObjective'); // prettier-ignore

export const grossOfferValue = currencyRangeColumn({
  Header: 'Gross Offer Value',
  accessor: 'grossOfferValue',
  id: 'grossOfferValue',
});

export const netClientBudget = currencyRangeColumn({
  Header: 'Net Client Budget',
  accessor: 'netClientBudget',
  id: 'netClientBudget',
});

export const listColumns = [
  primary,
  nameLink,
  created,
  modified,
  objective,
  withoutSum(grossOfferValue),
  withoutSum(netClientBudget),
  duplicate,
];
export const selectColumns = [
  name,
  createdBy,
  created,
  modifiedBy,
  modified,
  objective,
  grossOfferValue,
  netClientBudget,
];
